import type { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useCallback, useEffect, useState } from 'react';

type UseCampaignBasicsNameArgs = {
  setCampaignName: Dispatch<SetStateAction<string>>;
  setHasEditedCampaignName: Dispatch<SetStateAction<boolean>>;
};

export function useCampaignBasicsName({
  setCampaignName,
  setHasEditedCampaignName,
}: UseCampaignBasicsNameArgs) {
  const handleCampaignNameChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setHasEditedCampaignName(true);
      setCampaignName(event.target.value);
    },
    [setCampaignName, setHasEditedCampaignName],
  );

  return {
    handleCampaignNameChange,
  };
}

export function useDebouncedValue<TValue>(value: TValue, delayMs: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedValue(value);
    }, delayMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [delayMs, value]);

  return debouncedValue;
}
